import { Grid, styled, Typography } from '@mui/material';
import ZizziPoint from 'assets/icons/ZizziPoint';
import { theme } from 'assets/themes/zizzi';

export const DetailContainer = styled(Grid)`
  border-top: 1px solid ${theme.palette.neutral.main};
  justify-content: space-between;
  padding: ${theme.spacing(1)};
`;

export const DetailValue = styled(Typography)`
  font-weight: bold;
`;

export const StyledLogo = styled(ZizziPoint)`
  margin-left: 5px;
  height: 22px;
  width: 22px;
  margin-bottom: -4px;
`;
